import React from 'react';
import PropTypes from 'prop-types';
import { DateTime } from 'luxon';

import styles from './CheckoutMessage.css';
import { CHECKOUT_STATUS } from '../../models/Checkout';

const IPropTypes = {
  paymentMethodId: PropTypes.number,
  status: PropTypes.string,
  checkoutDate: PropTypes.instanceOf(DateTime),
};

const defaultProps = {
  paymentMethodId: 0,
  status: '',
  checkoutDate: null,
};

const CheckoutMessage = (props) => {
  const isSundayCheckout =
    props.checkoutDate &&
    props.checkoutDate.weekday === 7;

  // Pago banco domingo pendiente
  if (
    props.paymentMethodId === 4 &&
    props.status === CHECKOUT_STATUS.PENDING_PAYMENT &&
    isSundayCheckout
  ) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra! Estamos procesando tu solicitud de pago.</p>
        <p>
          Tu compra fue registrada correctamente y quedó pendiente
          de validación bancaria.
        </p>
        <p>
          Los pagos realizados durante el domingo serán procesados
          el próximo día hábil, por lo que el estado puede visualizarse
          temporalmente como “Pendiente de pago”.
        </p>
        <p>
          Podrás consultar las actualizaciones del pedido en
          {' '}
          Mis compras. A su vez, en caso de tu compra sea exitosa,
          recibirás un mail de confirmación el próximo día hábil.
        </p>
          ¡Gracias nuevamente por tu confianza!
      </div>
    );
  }

  // Rechazados
  if (
    [
      CHECKOUT_STATUS.PENDING,
      CHECKOUT_STATUS.PENDING_PAYMENT,
      CHECKOUT_STATUS.REJECT_PAYMENT,
      CHECKOUT_STATUS.DISABLED,
    ].includes(props.status) &&
    props.paymentMethodId !== 1 &&
    props.paymentMethodId !== 3 &&
    props.paymentMethodId !== 4
  ) {
    return (
      <div className={styles.container}>
        <p>Lamentamos que tu pago no haya podido ser realizado.</p>

        <p>
          Te invitamos a volver a agregar tus productos al carrito y
          probar realizar nuevamente el pago.
        </p>

        <p>¡Gracias por tu confianza!</p>
      </div>
    );
  }

  // Efectivo
  if (props.paymentMethodId === 1 || props.paymentMethodId === 3) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra!</p>

        <p>
          Tu pedido está siendo verificado y lo confirmaremos a la
          máxima brevedad posible (en horario laboral) y allí
          recibirás un mail con los detalles de tu compra.
        </p>

        <p>
          También podrás ver el estado de tu pedido en
          {' '}
          Mi cuenta / Mis compras.
        </p>

        <p>
          Finalmente, el pago deberás realizarlo en efectivo al
          momento de recibir tu compra.
        </p>

        <p>¡Gracias nuevamente por tu confianza!</p>
      </div>
    );
  }

  // Pago banco normal
  if (props.paymentMethodId === 4) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra!</p>

        <p>
          Tu pedido está confirmado. En unos minutos recibirás
          un mail con los detalles de tu compra.
        </p>

        <p>
          También podrás ver el estado de tu pedido en
          {' '}
          Mi cuenta / Mis compras.
        </p>

        <p>¡Gracias nuevamente por tu confianza!</p>
      </div>
    );
  }

  // Redpagos / Abitab
  if (props.paymentMethodId === 5) {
    return (
      <div className={styles.container}>
        <p>¡Muchas gracias por tu compra!</p>

        <p>
          Ya podés ir a un Abitab o Redpagos a realizar el pago,
          considerando:
        </p>

        <ul>
          <li>
            Decir que vas a hacer el pago a Carlos Gutiérrez SA.
          </li>

          <li>
            Mencionar el número de documento del titular de la cuenta
            con la que realizaste la compra.
          </li>
        </ul>

        <p>
          Podés abonar con tarjeta de débito.
          <br />
          Por su parte, en locales Abitab o en su App,
          podés pagar con tarjetas de crédito Anda,
          Passcard y Cabal (en 1 pago)
        </p>

        <p>
          Luego de recibir el pago, nosotros confirmaremos
          la recepción a la máxima brevedad posible
          (en horario laboral) y allí recibirás un mail
          con los detalles de tu compra.
        </p>

        <p>
          También podrás ver el estado de tu pedido en
          {' '}
          Mi cuenta / Mis compras.
        </p>

        <p>¡Gracias nuevamente por tu confianza!</p>
      </div>
    );
  }

  return null;
};

CheckoutMessage.propTypes = IPropTypes;
CheckoutMessage.defaultProps = defaultProps;

export { CheckoutMessage };



// WEBPACK FOOTER //
// ./src/common/checkout-message/CheckoutMessage.jsx